<template>

  <div id="app">
    <!--nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#">Navbar</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">Link</a>
      </li>     
      <li class="nav-item">
        <a class="nav-link disabled" href="#">Disabled</a>
      </li>
    </ul>
    <form class="form-inline my-2 my-lg-0">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
    </form>
  </div>
</nav-->

    <div id="nav">
      <div class="container">
        <div class="d-flex justify-content-between align-items-end">
          <img class="cursor-pointer" @click="$router.push('/')" alt="Emcali" src="@/assets/logo.png">
         
          <!--<v-icon class="cursor-pointer" name="user" v-if="$store.state.email" @click="logout" style="width: 50px; height: 50px;"/>-->
          <div class="d-flex flex-column align-content-center" v-if="$store.state.email" >
            <div>              
              <v-icon name="user" style="width: 50px; height: 50px;"/>
            </div>
            <div>              
              <label>{{ $store.state.email }}</label>
            </div>
            <div v-if="$store.state.email" >          
              <v-icon class="cursor-pointer" name="sign-out-alt" v-if="$store.state.email" @click="logout" style="width: 20px; height: 20px;"/><label class="cursor-pointer" @click="logout">cerrar sesión</label>
            </div>
          </div>
          <!--<v-icon class="cursor-pointer" name="user" v-if="!$store.state.email && $route.path == '/adminRequestList'" @click="$router.push('/adminLogin')" style="width: 50px; height: 50px;"/>-->
          <v-icon class="cursor-pointer" name="cog" @click="$router.push('/adminUserList')" v-if="$route.path == '/adminRequestList'" style="width: 50px; height: 50px;"/>
          
            <!--<router-link v-if="!$store.state.email" to="/adminLogin">Login</router-link>
            <router-link v-if="$store.state.email" @click="logout">Logout</router-link>
            <v-icon class="cursor-pointer" name="user" @click="$router.push('/adminLogin')" v-if="$route.path == '/adminRequestList'" style="width: 50px; height: 50px;"/>
            <v-icon class="cursor-pointer" name="list" @click="$router.push('/adminUserList')" v-if="$route.path == '/adminRequestList'" style="width: 50px; height: 50px;"/>-->
          
           <h1 v-if="$route.path == '/'">Tramite de proyectos eléctricos</h1>
          <h1 v-if="$route.path == '/form'">Formulario de solicitud de servicio</h1>
          <h1 v-if="$route.path == '/adminLogin'">Gestión proyectos de energía</h1>
          <h1 v-if="$route.path == '/consults'">Consultar solicitud</h1>
          <h1 v-if="$route.path == '/requestDetail' || $route.path == '/adminRequestDetail'">{{requestDetail.proyectName}}</h1>
        </div>
      </div>
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    </div>
    <router-view/>
  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  data(){
    return {}
  }, 
  methods: {
    logout(){
      this.$store.commit('logout')
      location.reload()
      this.$router.push('/adminLogin')
    }
  } ,
  mounted(){
    //agregar la validacion para redireccionar al login o dejar estar en la pantalla adminlist
    this.$store.commit('initializeStore')
  },
  computed: {
    ...mapState({
      requestDetail: state => state.requestDetail,
      userDetail: state => state.userDetail
    })

  }
}
</script>

<style lang="scss">

@import '@/assets/scss/_variables.scss';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}


#nav {
  padding: 20px;
  border-bottom: 1px solid #777;
  img {
    width: 200px;
  }
  h1 {
    font-size: 24px;
  }
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}


// Utilities
.uppercase {
  text-transform: uppercase;
}
.request-blue {
  background-color: $color-blue;
  padding: 5px;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  text-transform: capitalize;
}
.request-red {
  background-color: $color-red;
  padding: 5px;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  text-transform: capitalize;
}
.request-green {
  background-color: $color-green;
  padding: 5px;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  text-transform: capitalize;
}

[data-title]:hover:after {
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
}
[data-title]:after {
    content: attr(data-title);
    // background-color: #00FF00;
    color: $color-text;
    font-size: 150%;
    position: absolute;
    padding: 4px 8px;
    bottom: -1.6em;
    left: 100%;
    white-space: nowrap;
    box-shadow: 1px 1px 3px #222222;
    opacity: 0;
    border: 1px solid #111111;
    z-index: 99999;
    visibility: hidden;
}
[data-title] {
    position: relative;
}
.cursor-pointer {
  cursor: pointer;
}
.white-icon {
  fill: #fff;
}
.direction-separator {
  position: absolute;
  left: -5px;
  top: 35px;
}
.form-container {
  padding: 0 100px;
  &--box {
    max-width: 460px;
    margin: 0 auto;
    padding: 0;
  }
  @media (max-width:992px){
    padding: 0;
  }
}
.application-number {
  background-color: #eee;
  border-radius: 8px;
  padding: 10px 20px;
}
.bold {
  font-weight: bold;
}
.bg-yellow {
  background-color: rgba($color: $color-yellow, $alpha: 0.6);
}
.bg-blue {
  background-color: rgba($color: #3498db, $alpha: 0.6);
}
.bg-green {
  background-color: rgba($color: $color-green, $alpha: 0.6);
}
.bg-red {
  background-color: rgba($color: $color-1, $alpha: 0.6);
}
// .color-yellow {
//   color: rgba($color: $color-yellow, $alpha: 0.5);
// }
// .color-blue {
//   color: $color-blue !important;
// }

// theme
.document {
  width: 50%;
  // display: block;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid $color-text;
  margin-top:10px; 
  a {
    text-decoration: none;
    color: $color-text !important;
    font-weight: bold;
  }
  img {
    max-width: 100%;
  }
}
.screen-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner {
    fill: #fff;
    animation: spin 1s linear infinite;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.privacy-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
  }
  .modal-box {
    width: 100%;
    max-width: 90%;
    max-height: 90%;
    min-height: 100px;
    background-color: #fff;
    padding: 15px;
    border-radius: 8px;
    z-index: 9999;
    top: 0;
    overflow: scroll;
    position: relative;
    font-size: 14px;
    text-align: left;
    h2 {
      color: $color-1;
    }
    h3 {
      font-size: 18px;
      font-weight: bold;
    }
    h4 {
      font-size: 18px;
    }
  }
}
.error-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    position: absolute;
  }
  .modal-box {
    width: 100%;
    max-width: 450px;
    min-height: 100px;
    background-color: #fff;
    padding: 15px;
    border-radius: 8px;
    z-index: 9999;
    position: relative;
    font-size: 22px;
  }
}

.required-docs-list{
  width: 500vw !important;
  height: 300vh !important;
}

.historial-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    position: absolute;
  }
  .modal-box {
    overflow: scroll;
    width: 100%;
    max-width: 45%;
    min-height: 400px;
    max-height: 600px;
    background-color: #fff;
    padding: 15px;
    border-radius: 8px;
    z-index: 9999;
    position: relative;
    font-size: 14px;
  }
}
.carga-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    position: absolute;
  }
  .modal-box {
    overflow: scroll;
    width: 100%;
    max-width: 39%;
    min-height: 400px;
    max-height: 600px;
    background-color: #fff;
    padding: 15px;
    border-radius: 8px;
    z-index: 9999;
    position: relative;
    font-size: 20px;
  }
}
.steps-wrap {
  display: flex;
  justify-content: center;
  .step {
    display: flex;
    position: relative;
    align-items: center;
    margin-right: 10px;
    text-align: center;
    width: 150px;
    padding: 5px 10px;
    border-radius: 12px;
    font-weight: bold;
    border: 2px solid #0f8943;
    user-select: none;
    &.done {
      background-color: $color-green;
      color: #fff;
    }
    &.pending {
      
    }
    &.active {
      background-color: $color-blue;
      color: #fff;
      border: 2px solid $color-blue;
      animation: activeMove 1s infinite;
    }
    @keyframes activeMove {
      0%{
        transform: scale(1);
      }
      50%{
        transform: scale(1.03);
      }
      100%{
        transform: scale(1);
      }
    }
    &:not(:first-child){
      &::before {
        content: '';
        position: absolute;
        width: 10px;
        height: 2px;
        background-color: $color-text;
        left: -12px;
      }
    }
  }
}
.app-icon :hover {
  fill: $color-1;
  cursor: pointer;
}
.service-box {
  xdisplay: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  border-radius: 10px;
  border: 2px solid #777;
  max-width: 280px;
  width: 100%;
  &.opacity {
    opacity: 0.5;
    transition: 0.3s;
  }
  &:hover {
    opacity: 1;
  }
  &--yellow {
    border: 2px solid $color-yellow;
  }
  &--blue {
    border: 2px solid $color-blue;
  }
  .service-box-header {
    background-color: $color-gray-light;
    padding: 20px 10px;
    border-radius: 10px;
    color: #000;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
  }
  ul {
    list-style: circle;
    padding-left: 30px;
    margin: 0;
  }
}
.app-btn {
  width: max-content;
  height: 45px;
  // max-width: calc(100% - 20px);
  color: #fff;
  background-color: $color-1;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: bold;
  text-decoration: none;
  display: block;
  border-radius: 5px;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.4s;
  cursor: pointer;
  transition: .3s;
  @media all and (max-width: 992px) {
    padding: 6px;
  }
  &--sm {
    height: 30px;
    font-size: 12px;
    padding: 0 10px;
    // border-bottom: 0;
  }
  &:hover {
    transform: scale(1.03);
    color: #fff;
    text-decoration: none;
  }
  &--green {
    background-color: $color-green !important;
    border: 0;
    color: #fff !important;
    &.button--loading {
      &:after{
        background-color: #fff;
      }
      &:before{
        background-color: $color-green !important;
      }
    }
  }
  &--yellow {
    background-color: $color-yellow;
    border: 0;
    color: #000 !important;
  }
  &--admin {
    border-radius: 0;
    border: 0;
    &:hover {
      border:0;
    }
  }
  &--blue {
    background-color: $color-blue;
    color: #fff !important;
  }
  &--blue-imp {
    background-color: $color-blue !important;
    color: #fff !important;
  }
  &--red {
    background-color: $color-red;
    color: #fff !important;
  }
  &--purple {
    background-color: $color-purple;
    color: #fff !important;
  }
  &--big {
    width: 350px;
    height: 80px;
  }
  &--200 {
    width: 200px;
  }
  &--250 {
    width: 220px;
  }
  &--300 {
    width: 250px;
  }
  &.opacity {
    opacity: 0.6;
  }
}
.input-wrap {
  .file {
    padding: 10px 20px;
    border: 1px solid #000; 
    display: table;
    color: #000;
    border-radius: 8px;
    cursor: pointer;
  }
  label {
    margin: 3px;
  }
  input[type="file"] {
    display: none;
  }
  .file-selected {
    padding: 5px 15px;
    border-radius: 5px;
    border: 1px solid #777;
    background-color: #eee;
    display: table;
  }
  &.image-input {
    position: relative;
    input {
      visibility: hidden;
      height: 0;
      width: 0;
      left: 0;
      top: 0;
      position: absolute;
    }
  }
  input, textarea, select {
    padding: 10px;
    border-radius: 4px;
    border: 1px solid $color-gray;
    margin-bottom: 10px;
    width: 100%;
    &:focus {
      outline: none;
    }
    &:last-child {
      margin-bottom: 0;
    }
    &.error {
      border: 1px solid $color-red;
    }
    &.ok {
      border: 1px solid $color-green;
    }
    &.disabled {
      background-color: $color-gray;
      cursor: not-allowed;
      user-select: none;
    }
  }
}
.radio {
  margin: 0.5rem;
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 20px;
    + .radio-label {
      &:before {
        content: '';
        // background: $color-1;
        border-radius: 100%;
        border: 1px solid darken($color-1, 25%);
        display: inline-block;
        width: 1.4em;
        height: 1.4em;
        position: relative;
        top: 0;
        margin-right: 1em; 
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: #fff;
          box-shadow: inset 0 0 0 5px $color-1;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color-2;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color-1;
          border-color: darken($color-1, 25%);
          background: darken($color-1, 25%);
        }
      }
    }
    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}

@media print{    
    .no-print, .no-print *
    {
        display: none !important;
    }
    .si-print, .si-print *
    {
        display: block !important;
    }
}

.infoTab{
  line-height: 1 !important;
}

.puesta-en-servicio{
  background-color: #f3ffe6;
}

.factibilidad-servicio{
  background-color: #ffffcc;
}

.aprobacion-disenos{
  background-color: #ffebcc;
}

.ejecucion-obras{
  background-color: #e6f9ff;
}

.solicitud-servicio{
  background-color: #e6e6ff;
}

.anulado{
  background-color: #ffa9a9;
}

.finalizado{
  background-color: #ace5ac;
}
</style>